import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation";

const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 2000
};

const illustration = {
  animated: true
};

const greeting = {
  username: "Abhishek Tadepalli",
  title: "Hey, I'm Abhishek",
  subTitle: emoji(
    "An energetic and innovative Generative AI Engineer 🚀 specializing in agentic LLM frameworks, chatbots, and cloud deployments. Passionate about developing state-of-the-art AI solutions within a dynamic team setting."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1UTJ-GC9Vibq82v_VAAYvCvI88DysqNg9/view?usp=drive_link",
  displayGreeting: true
};

const socialMediaLinks = {
  github: "https://github.com/Abhishekjoel96",
  linkedin: "https://www.linkedin.com/in/abhishek-tadepalli-56245ab3",
  gmail: "abhishekjoel58@gmail.com",
  display: true
};

const skillsSection = {
  title: "What I do",
  subTitle: "PASSIONATE GENERATIVE AI ENGINEER WHO SPECIALIZES IN CUTTING-EDGE AI SOLUTIONS",
  skills: [
    emoji(
      "⚡ Implement Retrieval-Augmented Generation (RAG) pipelines with vector databases for enhanced information retrieval"
    ),
    emoji("⚡ Develop scalable AI solutions using LangChain and LlamaIndex frameworks"),
    emoji(
      "⚡ Fine-tune both open-source and paid LLM models (Llama2, Mistral, OpenAI, Gemini Pro) for specific project requirements"
    ),
    emoji(
      "⚡ Deploy AI applications on cloud platforms including AWS, Azure Functions, GCP, and Hugging Face Spaces"
    )
  ],
  softwareSkills: [
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "react",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node-js"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "azure",
      fontAwesomeClassname: "fab fa-microsoft"
    },
    {
      skillName: "google-cloud",
      fontAwesomeClassname: "fab fa-google"
    },
    {
      skillName: "database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "api",
      fontAwesomeClassname: "fas fa-server"
    },
    {
      skillName: "ai",
      fontAwesomeClassname: "fas fa-robot"
    },
    {
      skillName: "machine-learning",
      fontAwesomeClassname: "fas fa-brain"
    }
  ],
  display: true
};

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "GITAM University",
      logo: require("./assets/images/gitam-university.png"),
      subHeader: "Bachelor of Science in Civil Engineering",
      duration: "Graduated 2018",
      desc: "Completed my bachelor's degree in Civil Engineering at Visakhapatnam.",
      descBullets: []
    },
    {
      schoolName: "100x Engineers",
      logo: require("./assets/images/100x-engineers.png"),
      subHeader: "Applied GenAI Cohort Program",
      duration: "2023",
      desc: "Intensive program focused on practical application of Generative AI technologies.",
      descBullets: []
    }
  ]
};

const techStack = {
  viewSkillBars: true,
  experience: [
    {
      Stack: "Generative AI & LLM",
      progressPercentage: "95%"
    },
    {
      Stack: "RAG & Vector Databases",
      progressPercentage: "90%"
    },
    {
      Stack: "Cloud Deployment",
      progressPercentage: "85%"
    },
    {
      Stack: "Python Programming",
      progressPercentage: "70%"
    },
    {
      Stack: "Web Development (React, Node.js)",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false
};

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Generative AI Engineer",
      company: "Freelance/Projects",
      companylogo: require("./assets/images/experience-logo-1.png"),
      date: "2023 – Present",
      desc: "Specializing in agentic LLM frameworks, chatbots, and cloud deployments. Developing state-of-the-art AI solutions including RAG systems, intelligent agents and AI applications."
    },
    {
      role: "Music Instructor",
      company: "The Global Edge School",
      companylogo: require("./assets/images/experience-logo-2.png"),
      date: "2023 – 2024",
      desc: "Provided music instruction and developed student engagement strategies at The Global Edge School in Kokapet, Hyderabad."
    },
    {
      role: "Commercial Real Estate Broker",
      company: "Hyderabad",
      companylogo: require("./assets/images/experience-logo-3.png"),
      date: "2022 – 2023",
      desc: "Facilitated commercial real estate transactions, specializing in identifying and securing locations for dark stores for major clients like Blinkit and Swiggy. Managed client relationships and negotiations."
    },
    {
      role: "Founder & Operator",
      company: "Joel School of Music",
      companylogo: require("./assets/images/experience-logo-4.png"),
      date: "2019 – 2022",
      desc: "Established and managed operations, curriculum, and client relations for an independent music school in Hyderabad."
    }
  ]
};

const openSource = {
  showGithubProfile: "true",
  display: true
};

const bigProjects = {
  title: "Projects",
  subtitle: "AI SOLUTIONS AND APPLICATIONS I'VE DEVELOPED",
  projects: [
    {
      image: require("./assets/images/ai-whatsapp-fashion-assistant.png"),
      projectName: "AI-powered WhatsApp Fashion Assistant",
      projectDesc: "AI assistant for WhatsApp offering personalized fashion advice using skin tone analysis and virtual try-on. Achieved 95% accuracy. Stack: React.js, Node.js, OpenAI, Twilio, Cloudinary.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://whats-app-fashion-buddy-abhishekjoel58.replit.app"
        }
      ]
    },
    {
      image: require("./assets/images/ai-teaching-assistant.png"),
      projectName: "AI-Powered Teaching Assistant",
      projectDesc: "Integrated app with AI bots for learning: summary, quiz, and notes generation. Enables fast content review and testing. Stack: Streamlit, OpenAI API, YouTube Transcript API, Python.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://studyscribe.framer.ai/"
        }
      ]
    },
    {
      image: require("./assets/images/ai-crm-communications.png"),
      projectName: "AI-powered CRM and Communication Platform",
      projectDesc: "AI platform automating lead management, messaging, and analytics. Features real-time updates and multi-channel support. Stack: React, Node.js, WebSocket, OpenAI, SQL, Twilio, Chart.js.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://sales-pro-abhishekjoel58.replit.app"
        }
      ]
    }
  ],
  display: true
};

const achievementSection = {
  title: emoji("Certifications & Participations 🏆 "),
  subtitle:
    "Courses, certifications, and AI challenges I've completed to enhance my skills",
  achievementsCards: [
    {
      title: "Machine Learning with Python",
      subtitle: "Coursera",
      image: require("./assets/images/certification-1.png"),
      imageAlt: "Coursera Logo",
      footerLink: []
    },
    {
      title: "Gen AI for Beginners",
      subtitle: "Microsoft",
      image: require("./assets/images/certification-2.png"),
      imageAlt: "Microsoft Logo",
      footerLink: []
    },
    {
      title: "Introduction to Gen AI",
      subtitle: "Google Cloud",
      image: require("./assets/images/certification-3.png"),
      imageAlt: "Google Logo",
      footerLink: []
    },
    {
      title: "Generative AI for Everyone",
      subtitle: "DeepLearning.AI",
      image: require("./assets/images/certification-4.png"),
      imageAlt: "DeepLearning.AI Logo",
      footerLink: []
    },
    {
      title: "Introduction to Gen AI",
      subtitle: "IBM",
      image: require("./assets/images/certification-5.png"),
      imageAlt: "IBM Logo",
      footerLink: []
    },
    {
      title: "IBM Skill Fest",
      subtitle: "Participant",
      image: require("./assets/images/certification-5.png"),
      imageAlt: "IBM Logo",
      footerLink: []
    },
    {
      title: "Microsoft AI Skill Fest",
      subtitle: "Participant",
      image: require("./assets/images/certification-2.png"),
      imageAlt: "Microsoft Logo",
      footerLink: []
    },
    {
      title: "Nas.io AI Challenge",
      subtitle: "Participant",
      image: require("./assets/images/certification-8.png"),
      imageAlt: "Nas.io Logo",
      footerLink: []
    }
  ],
  display: true
};

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true",
  blogs: [],
  display: false
};

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY KNOWLEDGE AND EXPERIENCES"
  ),
  talks: [],
  display: false
};

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT AI AND TECHNOLOGY",
  podcast: [],
  display: false
};

const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  display: true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91 8374112600",
  email_address: "abhishekjoel58@gmail.com",
  location: "Hyderabad, Telangana"
};

const twitterDetails = {
  userName: "twitter",
  display: false
};

const isHireable = true;

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
